/*
  RS cart links: a cart action link the theme has already handled is not opened a second time.
  The cart page's remove links are real links (<a href="/cart/change?id=…&quantity=0">, they work
  without JavaScript); Dawn's <cart-remove-button> stops the link and removes the line with fetch.
  The VBOUT tracker (outside the theme, "link tracking") listens for every link click on document,
  ignores that the click was already handled and opens the link itself (window.location = href):
  the line was removed twice and Shopify showed "ID o parametri di linea non validi" (1.74 preview,
  owner's test). Here a click on a link to /cart/add, /cart/change, /cart/clear or /cart/update
  whose default action was already prevented stops at <html>, before the listeners on document.
  Other links (and cart links nobody handled) go on as before, so trackers still see them.
  Loaded by snippets/rs-cart-scripts.liquid.
*/
(() => {
  if (window.rsCartLinks) return;
  window.rsCartLinks = true;

  const CART_ACTION = /\/cart\/(add|change|clear|update)(\.js)?$/;

  document.documentElement.addEventListener('click', (event) => {
    if (!event.defaultPrevented) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    try {
      if (CART_ACTION.test(new URL(link.href, window.location.href).pathname)) event.stopPropagation();
    } catch (error) {
      // Not a valid URL: nothing to protect
    }
  });
})();
